import React from "react";
import { Card, Table, Row, Col, Button, Image } from "react-bootstrap";
import { useGetInvoiceDetailsQuery } from "../../../Service/invoices";
import printJS from "print-js";
import Loader from "../../../Component/DigitalMarketing/Loader";
import { formatWord } from "../Utils/utils";
import invoicelogo from "../../../assets/DigitalMarketing/image/invoicelogo.jpg";

const InvoiceDetails = ({ data, setShow }: any) => {
  const { data: invoiceData, isLoading } = useGetInvoiceDetailsQuery(
    { id: data?.customerId },
    { refetchOnMountOrArgChange: true }
  );

  const handlePrint = (invoiceNumber: string) => {
    printJS({
      printable: `invoice-${invoiceNumber}`,
      type: "html",
      css: "https://cdn.jsdelivr.net/npm/bootstrap/dist/css/bootstrap.min.css",
      onPrintDialogClose: () => {
        setShow(false);
      },
    });
  };

  if (isLoading) return <Loader loading={true} />;

  const invoices = invoiceData?.data || [];

  return (
    <>
      {invoices.length > 0 ? (
        invoices.map((invoice: any, index: number) => (
          <Card key={invoice.invoiceNumber} className="mb-5 shadow-sm border-0">
            {/* Printable Section */}
            <div id={`invoice-${invoice.invoiceNumber}`} className="p-4">
              {/* Header */}
              <Row className="mb-4 align-items-center border-bottom pb-3">
                <Col lg={3}>
                  <Image
                    src={invoicelogo}
                    alt="Clinic Logo"
                    fluid
                    style={{ maxHeight: "70px" }}
                  />
                </Col>
                <Col lg={9} className="text-end">
                  <h5 className="fw-bold mb-1 text-primary">
                    LIVF Fertility & Women's Healthcare
                  </h5>
                  <div className="small text-muted">
                    23, Ground floor, 1st Cross St, Ramappa Nagar,
                    Kandhanchavadi, Perungudi, Chennai, Tamil Nadu 600096
                  </div>
                  <div className="small">📞 7878784079</div>
                  <div className="small">🌐 www.livffertility.com</div>
                </Col>
              </Row>

              {/* Invoice Info */}
              <Row className="mb-3 border-bottom pb-2">
                <Col lg={6}>
                  <h6 className="fw-bold">
                    Invoice No: {invoice?.invoiceNumber}
                  </h6>
                  <div className="text-muted">
                    Date:{" "}
                    {invoice?.invoiceDate
                      ? new Date(invoice.invoiceDate).toLocaleString("en-IN", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : ""}
                  </div>
                  <div className="mt-2">
                    <strong>Patient:</strong> {formatWord(invoice?.patientName)}
                  </div>
                </Col>
                <Col lg={6} className="text-end">
                  <div>
                    <strong>Payment Mode:</strong>{" "}
                    <span className="text-capitalize">
                      {invoice?.paymentMode || "-"}
                    </span>
                  </div>
                  <div>
                    <strong>Payment Type:</strong>{" "}
                    {invoice?.payment_type || "-"}
                  </div>
                  <div>
                    <strong>Status:</strong>{" "}
                    <span
                      className={
                        invoice?.paymentStatus === "completed"
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {invoice?.paymentStatus || "-"}
                    </span>
                  </div>
                </Col>
              </Row>

              {/* Treatments Table */}
              <Table bordered responsive className="mt-3">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Procedure</th>
                    <th>Price (₹)</th>
                    <th>CGST (₹)</th>
                    <th>SGST (₹)</th>
                    <th>Total (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {invoice?.treatments?.length > 0 ? (
                    invoice.treatments.map((t: any, i: number) => (
                      <tr key={t.id || i}>
                        <td>{i + 1}</td>
                        <td>{t.procedure}</td>
                        <td>{t.price}</td>
                        <td>{t.cgst}</td>
                        <td>{t.sgst}</td>
                        <td>{t.total}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">
                        No treatments found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* Totals Section */}
              <Row className="mt-4 border-top pt-3">
                <Col lg={6}>
                  <div className="fw-bold">Total in Words:</div>
                  <div className="text-muted fst-italic">
                    {invoice?.totalInWords || "-"}
                  </div>
                </Col>
                <Col lg={6} className="text-end">
                  <div>Price Total: ₹ {invoice?.priceTotal || "0.00"}</div>
                  <div>CGST Total: ₹ {invoice?.cgstTotal || "0.00"}</div>
                  <div>SGST Total: ₹ {invoice?.sgstTotal || "0.00"}</div>
                  <hr />
                  <h5 className="text-primary fw-bold">
                    Grand Total: ₹ {invoice?.totalAmount || "0.00"}
                  </h5>
                  <hr />
                  <h5 className="fw-bold" style={{ color: "#009688" }}>
                    Paid Amount: ₹ {invoice?.paidAmount || "0.00"}
                  </h5>
                   <hr />
                </Col>
              </Row>
            </div>

            {/* Print Button */}
            <div className="text-end mt-3 px-4 pb-4">
              <Button
                variant="primary"
                onClick={() => handlePrint(invoice.invoiceNumber)}
                className="d-flex align-items-center gap-2 ms-auto"
              >
                <span className="material-symbols-outlined">print</span>
                <span>Print Invoice</span>
              </Button>
            </div>
          </Card>
        ))
      ) : (
        <div className="text-center mt-4 text-muted">
          No invoices found for this patient.
        </div>
      )}
    </>
  );
};

export default InvoiceDetails;
